export const CHANGE_NEW_PERSON_STEP = "changeNewPersonStep";
export const CLEAR_FILTER_PERSONNEL = "clearFilterPersonnel";
export const FATAL_FETCH_ERROR = "fetchPersonnelError";
export const FETCH_START = "setLoading";
export const FILTER_PERSONNEL = "filterPersonnel";
export const FILTER_PERSONNEL_BY_DEPARTMENT = "FILTER_PERSONNEL_BY_DEPARTMENT";
export const FILTER_PERSONNEL_BY_EMPLOYMENT_TYPE = "FILTER_PERSONNEL_BY_EMPLOYMENT_TYPE";
export const FILTER_PERSONNEL_BY_IS_LIVE = "filterPersonnelByIsLive";
export const FILTER_PERSONNEL_BY_JOB = "filterPersonnelByJob";
export const LOAD_PERSON_SUMMARY_TO_EDIT = "loadPersonSummaryToEdit";
export const RESET_DEFAULT_PERSON_SUMMARY_TO_EDIT = "resetDefaultPersonSummaryToEdit ";
export const RESET_NEW_PERSON_TO_DEFAULT = "resetNewPersonToDefault";
export const RESET_PERSON = "resetPerson";
export const SAVE_NEW_PERSON_SUCCESSFUL = "saveNewPersonSuccessful";
export const SET_CONTRACTOR_STATUS = "setContractorStatus";
export const SET_EDIT_PERSON_FORM_SECTION_STATE = "setEditPersonFormSectionState";
export const SET_NEW_PERSON_FORM_SECTION_STATE = "setNewPersonFormState";
export const SET_PERSON = "setPerson";
export const SET_PERSONNEL = "setPersonnel";
export const TOGGLE_EDIT_PERSON_SUMMARY_DIALOG = "toggleEditPersonSummaryDialog";
export const UPDATE_NEW_PERSON = "updateNewPerson";
export const UPDATE_PERSON_MAIN_DETAILS_FIELD = "updatePersonMainDetailsField";
export const UPDATE_USER_PERMISSION = "updateUserPermission";
